import React from "react";
import Link from "gatsby-link";
import Script from "react-load-script";
import graphql from "graphql";

import {LanguagePageTemplate} from '../templates/language-page';

export default class IndexPage extends React.Component {
  handleScriptLoad() {
    if (typeof window !== `undefined` && window.netlifyIdentity) {
      window.netlifyIdentity.on("init", user => {
        if (!user) {
          window.netlifyIdentity.on("login", () => {
            document.location.href = "/admin/";
          });
        }
      });
    }
    window.netlifyIdentity.init();
  }

  render() {
    const data = this.props.data;
    const allLanguages = data.allMarkdownRemark.edges.map(post => {
      return {
        language: post.node.frontmatter.language,
        path: post.node.frontmatter.path
      }
    });

    const mainPage = data.allMarkdownRemark.edges
     .filter(post => post.node.frontmatter.path === '/en')
     .map(({ node: post }, i) => {
       const language = {
         allLanguages: allLanguages,
         selected: post.frontmatter.language
       }
       return (
         <LanguagePageTemplate
           key={i}
           meta={post.frontmatter.meta}
           intro={{content: post.frontmatter.intro, language: language}}
           about={post.frontmatter.about}
           gallery={post.frontmatter.gallery}
           oldCatalyst={post.frontmatter.oldCatalyst}
           creators={post.frontmatter.creators}
           footer={{content: post.frontmatter.footer, language: language}}
         />
       )
     })

    return (
      <section className="section">
        <Script
          url="https://identity.netlify.com/v1/netlify-identity-widget.js"
          onLoad={() => this.handleScriptLoad()}
        />
        {mainPage}
      </section>
    );
  }
}

export const pageQuery = graphql`
  query LanguagePageByLanguage {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            path
            language
            path
            date(formatString: "MMMM DD, YYYY")
            meta {
              title
              description
            }
            intro {
              title
              googleLogin {
                label
                url
                shortened
              }
              apply {
                label
                labelLink
                url
              }
            }
            about {
              title
              description
              image
            }
            gallery {
              title
              description
              list {
                text
                bg
                img
                title
                description
              }
            }
            oldCatalyst {
              title
              description
              image
            }
            creators {
              title
              testimonials {
                author
                avatar
                quote
              }
            }
            footer {
              support {
                label
                url
              }
              tos {
                label
                url
              }
              privacy {
                label
                url
              }
              community {
                label
                url
              }
              bbtvCopyright
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js